//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/src/assets/css/dialog.scss"
import Service from "@views/footer/service";
export default {
  name: "ContactUs",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, cb) => {
      const reg = /^1[3456789]\d{9}$/
      if (!reg.test(value)) {
        cb(new Error('请输入正确的手机号'))
      } else {
        cb()
      }
    }

    return {
      contactForm: {
        userName: '',
        companyName: '',
        mobile: '',
        email: '',
        consultationContent: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '请输入您的公司名称', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱', trigger: 'blur' },
          {
            pattern: Peace.validate.pattern.email,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        consultationContent: [
          { required: true, message: '请输入您的咨询内容', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    onBeforeClose() {
      this.$refs.contactForm.resetFields();
      this.closeModal()
    },
    closeModal() {
      this.$emit('update:dialogVisible', false)
    },
    handleConfirm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          Service.contactUs(this.contactForm).then(() => {
            Peace.util.success('留言成功，我们将尽快与您联系，请耐心等候！')
            this.closeModal()
          })
        } else {
          return false;
        }
      });
    }
  }
}
